module.exports = __webpack_public_path__ + "img/readonly.e43b29de.png";